module.exports = __webpack_public_path__ + "img/32c39e3.jpg";